export const TypesAvariaMovimentacaoVolume = {
    SET_PROPERTY: "avariaMovimentacaoVolume/SET_PROPERTY",
    RESET_AVARIAS_VOLUME: "avariaMovimentacaoVolume/RESET_AVARIAS_VOLUME",
}

export const INITIAL = {
    Etiqueta: '',
    EtiquetaFormatada: '',
    DetalhesEtiqueta: '',
    LocaisAvaria: [],
    TiposAvaria: [],
    ComplementosAvaria: [],
    ProvidenciasAvaria: [],
    avariaLocalChecked: [],
    avariaTipoChecked: [],
    avariaComplementoChecked: [],
    avariaProvidenciaChecked: [],
    avariaPeso: '',
    observacao: '',
    Avarias: []
}

export default function avariaMovimentacaoVolumeReducer(state = INITIAL, action) {
    switch (action.type) {
        case TypesAvariaMovimentacaoVolume.SET_PROPERTY:

            let obj = {};

            Object.assign(obj, state);

            obj[action.payload.campo] = action.payload.valor;

            return obj;
        case TypesAvariaMovimentacaoVolume.RESET_AVARIAS_VOLUME:
            return {
                ...state,
                Etiqueta: '',
                EtiquetaFormatada: '',
                DetalhesEtiqueta: '',
                avariaLocalChecked: [],
                avariaTipoChecked: [],
                avariaComplementoChecked: [],
                avariaProvidenciaChecked: [],
                avariaPeso: '',
                Avarias: []
            };
        default:
            return state;
    }
}

export const AvariaMovimentacaoVolumeActions = {
    setProperty,
    resetAvariaMovimentacaoVolume
}

function setProperty(valor, campo) {
    return {
        type: TypesAvariaMovimentacaoVolume.SET_PROPERTY,
        payload: { valor: valor, campo: campo }
    };
}

function resetAvariaMovimentacaoVolume() {
    return {
        type: TypesAvariaMovimentacaoVolume.RESET_AVARIAS_VOLUME
    };
}